export default __webpack_public_path__ + "static/media/bt_logo.a5c77630.svg";